/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};

// 获取结算单列表
exports.getSettleProofPagedList = function (data, callback) {// 获取结算单列表
    api.post('/settle/proof/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 获取结算单信息
exports.getSettleProof = function (id, callback) {// 获取结算单信息
    api.get('/settle/proof/get')
        .params({
            id: id
        })
        .done(callback)
        .go();
};
// 结算单申请操作
exports.doSettleProofApplied = function (data, callback) {// 结算单申请操作
    api.post('/settle/proof/applied/do')
        .data(data)
        .done(callback)
        .go();
};
// 结算单审核操作
exports.doAuditSettleProof = function (data, callback) {// 结算单审核操作
    api.post('/settle/proof/audit/do')
        .data(data)
        .done(callback)
        .go();
};
// 结算单业务冲销
exports.doPullBackSettleProofById = function (data, callback) {
    api.post('/settle/proof/pullBack/do/by/id')
        .data(data)
        .done(callback)
        .go();
};
// 结算单业务冲销申请
exports.doApplySettleProofPullBack = function (data, callback) {
    api.post('/settle/proof/pullBack/apply/do')
        .data(data)
        .done(callback)
        .go();
};
// 结算单业务冲销审核
exports.doAuditSettleProofPullBack = function (data, callback) {
    api.post('/settle/proof/pullBack/audit/do')
        .data(data)
        .done(callback)
        .go();
};
// 结算单作废操作
exports.doInvalidSettleProof = function (data, callback) {// 结算单作废操作
    api.post('/settle/proof/invalid/do')
        .data(data)
        .done(callback)
        .go();
};
// 结算单-支付完成
exports.updateSettleProofPaymentFinished = function (id, callback) {
    api.post('/settle/proof/paymentFinished/update/do')
        .data({
            id: id
        })
        .done(callback)
        .go();
};
// 结算业务项中的利润中心列表
exports.getSettleBizSrcPrftCenterCodeList = function (proofId, callback) {// 结算业务项中的利润中心列表
    api.get('/settle/biz/src/prftCenterCode/list/get')
        .params({
            proofId: proofId
        })
        .done(callback)
        .go();
};
// 结算关联发票
exports.doSettleProofRelInvoiceVoucher = function (data, callback) {
    api.post('/settle/proof/rel/invoice/voucher/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.updateSettleInvoiceItemForRemove = function (data, callback) {
    api.post('/settle/proof/invoice/item/for/remove')
        .data(data)
        .done(callback)
        .go();
};

exports.getSettleInvoiceItemList = function (data, callback) {// 结算发票项列表
    api.post('/settle/proof/invoice/items/get')
        .data(data)
        .done(callback)
        .go()
};

// 收货/退货验收单生成结算单
exports.savePurchReceiptSettleProof = function (data, callback) {
    api.post('/settle/purch/receipt/settle/proof/save/do')
        .data(data)
        .done(callback)
        .go();
};

// 工单验收单生成结算单
exports.saveSettleProofByServcWorkVoucher = function (data, callback) {
    api.post('/settle/servc/work/settle/proof/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 设置结算标签
exports.updateSettleTag = function (data, callback) {
    api.post('/settle/servc/settle/tag/update/do')
        .data(data)
        .done(callback)
        .go();
};
//
exports.doExportPayVouhcer = function (data, callback) {
    api.post('/settle/export/pay/voucher')
        .data(data)
        .done(callback)
        .go();
};

// ==================== 结算支付项 ==================
// 获取结算支付项列表
exports.getSettlePayItemList = function (data, callback) {
    api.post('/settle/pay/item/list/get')
        .data(data)
        .done(callback)
        .go();
};
// ================== 结算阶段 ==================
// 结算业务凭单
exports.getSettleBizProofPagedList = function (data, callback) {
    api.post('/settle/biz/proof/pages/list/get')
        .data(data)
        .done(callback)
        .go()
}

exports.getSettleBizItemPageList = function (data, callback) {
    api.post('/settle/biz/proof/item/list/page/get')
        .data(data)
        .done(callback)
        .go()
}

exports.doSettleProofFiscalSsp = function (data, callback) {
    api.post('/settle/proof/fiscalSsp/do')
        .data(data)
        .done(callback)
        .go()
};

exports.sendSettleProofPushOutSystem = function (data, callback) {
    api.post('/settle/proof/push/outSystem/do')
        .data(data)
        .done(callback)
        .go()
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/settle.js
// module id = 78
// module chunks = 0